// services/NotificationService.js

export class NotificationService {
  constructor(notificationCallback) {
    this.notify = notificationCallback;
  }
  
  success(message, title = 'Success') {
    this.notify({
      type: 'success',
      message,
      title
    });
  }
  
  error(message, title = 'Error') {
    this.notify({
      type: 'error',
      message,
      title
    });
  }
  
  warning(message, title = 'Warning') {
    this.notify({
      type: 'warning',
      message,
      title
    });
  }
  
  info(message, title = 'Info') {
    this.notify({
      type: 'info',
      message,
      title
    });
  }
  
  // Helper for async operations
  async withNotification(promise, { 
    loadingMessage = 'Processing...', 
    successMessage = 'Operation completed successfully',
    errorMessage = 'Operation failed'
  }) {
    try {
      const result = await promise;
      this.success(successMessage);
      return result;
    } catch (error) {
      this.error(`${errorMessage}: ${error.message}`);
      throw error;
    }
  }
}